var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.799805,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2598 20C36.4898 20.35 35.6598 20.58 34.7998 20.69C35.6798 20.16 36.3598 19.32 36.6798 18.31C35.8498 18.81 34.9298 19.16 33.9598 19.36C33.1698 18.5 32.0598 18 30.7998 18C28.4498 18 26.5298 19.92 26.5298 22.29C26.5298 22.63 26.5698 22.96 26.6398 23.27C23.0798 23.09 19.9098 21.38 17.7998 18.79C17.4298 19.42 17.2198 20.16 17.2198 20.94C17.2198 22.43 17.9698 23.75 19.1298 24.5C18.4198 24.5 17.7598 24.3 17.1798 24V24.03C17.1798 26.11 18.6598 27.85 20.6198 28.24C19.9906 28.4122 19.3299 28.4362 18.6898 28.31C18.9615 29.1625 19.4934 29.9084 20.2109 30.4429C20.9283 30.9775 21.7953 31.2737 22.6898 31.29C21.1735 32.4904 19.2938 33.1393 17.3598 33.13C17.0198 33.13 16.6798 33.11 16.3398 33.07C18.2398 34.29 20.4998 35 22.9198 35C30.7998 35 35.1298 28.46 35.1298 22.79C35.1298 22.6 35.1298 22.42 35.1198 22.23C35.9598 21.63 36.6798 20.87 37.2598 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTwitter);
export default __webpack_public_path__ + "static/media/share-twitter.56d3c8280f2129c9ccfa4c085b439405.svg";
export { ForwardRef as ReactComponent };